import { render, staticRenderFns } from "./taskDelete.vue?vue&type=template&id=38c58d78&scoped=true&"
import script from "./taskDelete.vue?vue&type=script&lang=js&"
export * from "./taskDelete.vue?vue&type=script&lang=js&"
import style0 from "./taskDelete.vue?vue&type=style&index=0&id=38c58d78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c58d78",
  null
  
)

export default component.exports